<script>
import Layout from '../../../layouts/auth'
import appConfig from '@/app.config'
import { required, minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import McInputNumber from '@/components/McInputNumber'
import * as verificationApi from '@/services/rest-api-identity/lib/verification/verification'
import { GET_USER, UPDATE_USER } from '@/services/api/master/user'
import { patchProfile } from '@/services/rest-api-vsms/lib/profile/profile'

export default {
  page: {
    title: 'Ubah Nomor Telepon',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    McInputNumber,
  },
  mixins: [Helper],
  data() {
    return {
      phoneNo: '',
    }
  },
  validations: {
    phoneNo: {
      required,
      minLength: minLength(10),
    },
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
    profile() {
      return this.$store.state.access.profile
    },
  },
  mounted() {
    this.adjustImageSize()
    this.$v.$touch()
  },
  methods: {
    async handleSubmit() {
      this.$v.$touch()

      const INTERNAL_USER_API =
        process.env.VUE_APP_ENV === 'production'
          ? process.env.VUE_APP_INTERNAL_USER_PROD_API
          : process.env.VUE_APP_INTERNAL_USER_API

      try {
        if (this.profile.isPhoneVerified) {
          const data = await this.$apollo
            .query({
              query: GET_USER,
              variables: {
                input: {
                  phoneNo: this.phoneNo,
                },
              },
            })
          const userIsExist = data.data.user.user;
          if (userIsExist) {
            this.$mcToast.error(this.$t('profile.update.phoneExist'));
            return;
          }

          const res = await verificationApi.sendEmailVerification({
            resource_url: `${INTERNAL_USER_API}${this.profile.userId}`,
            verification_type: 'phone',
            phone_no: this.phoneNo,
          })

          if (!res.status) {
            this.$mcToast.error(this.$t('profile.update.failedSend'))
          }

          this.$mcToast.success(this.$t('profile.update.dataSaved'))
          setTimeout(() => {
            this.$router.push({ name: 'Profile' })
          }, 1000)
        } else {
          const patchUserResponse = await patchProfile({
            phone_no: this.phoneNo,
          })

          if (patchUserResponse?.status) {
            const res = await verificationApi.sendEmailVerification({
              resource_url: `${INTERNAL_USER_API}${this.profile.userId}`,
              verification_type: 'phone',
              phone_no: this.phoneNo,
            })

            if (!res.status) {
              this.$mcToast.error(this.$t('profile.update.failedSend'))
            }

            this.$mcToast.success(this.$t('profile.update.dataSaved'))
            setTimeout(() => {
              window.location.href = '/profile'
            }, 1000)
          } else {
            this.$mcToast.error(this.$t('profile.update.phoneExist'))
          }
        }
      } catch (error) {
        this.$mcToast.error(this.$t('profile.update.failed'))
        this.isSubmit = false
      }
    },
    adjustImageSize() {
      this.resizeImage(this.$refs.imgPrimaryLogo, 45, 150)
      this.resizeImage(this.$refs.imgCopyrightLogo, 15, 50)
    },
  },
}
</script>
<style scoped lang="scss">
@mixin custom-tooltip-styles {
  position: absolute;
  padding: 10px;
  background: $white;
  z-index: 1;
  border: 1px solid $teal-200;
  border-radius: 4px;
  &:before {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 5px 5px;
    border-color: $teal-200 transparent;
    left: 50%;
    top: -2px;
    transform: translate(-50%, -50%);
  }
  &:after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 4px 4px;
    border-color: $white transparent;
    left: 50%;
    top: -1px;
    transform: translate(-50%, -50%);
  }
}

.custom-tooltip {
  @include custom-tooltip-styles;
  transform: translate(19%, -1%);
  ul li label {
    max-width: 233px;
  }
}

.custom-tooltip-repassword {
  @include custom-tooltip-styles;
  transform: translate(50%, -1%);
}

.icon-success:before {
  color: $success;
  font-size: 14px;
}
.icon-danger:before {
  color: $danger;
  font-size: 14px;
}
</style>
<template>
  <Layout>
    <div class="mc-auth__form">
      <h1 class="mc-auth__logo pt-5">
        <router-link to="/">
          <img :src="getAsset('primaryLogo', 'login')" alt ref="imgPrimaryLogo" />
        </router-link>
      </h1>
      <div class="mc-auth__form-wrapper mc-auth__form-wrapper--forgot">
        <h4 class="mc-auth__label">{{ $t('profile.update.phone.title') }}</h4>
        <p>{{ $t('profile.update.phone.description') }}</p>
        <b-form @submit.prevent="handleSubmit">
          <b-form-group class="mb-3 form-password text-start" id="input-group-1">
            <label for="text-password">
              {{ $t('profile.update.phone.labelOld') }} <span class="text-danger">*</span></label
            >
            <mc-input-number
              id="phone_number"
              name="phoneNo"
              v-model="profile.phoneNo"
              :disabled="true"
              :invalidMsg="$t('master.form.employee.phoneFormat')"
              :placeholder="$t('profile.update.phone.labelOld')"
            />
          </b-form-group>
          <b-form-group class="mb-2 form-password text-start" id="input-group-2">
            <label for="text-repassword"
              >{{ $t('profile.update.phone.labelNew') }} <span class="text-danger">*</span></label
            >
            <mc-input-number
              id="phone_number"
              name="phoneNo"
              v-model="$v.phoneNo.$model"
              :invalidMsg="$t('master.form.employee.phoneFormat')"
              :placeholder="$t('profile.update.phone.labelNew')"
              @onChange="(val) => ($v.phoneNo.$model = val)"
            />
          </b-form-group>
          <div class="mt-5">
            <b-button type="submit" variant="primary" class="w-100" :disabled="$v.phoneNo.$invalid"
              >{{ $t('profile.update.phone.button') }}
            </b-button>
          </div>
        </b-form>
      </div>
      <div class="mc-auth__copyright">
        <span
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
          >{{ $t('login.text.presented') }}
          <img
            :src="getAsset('copyrightLogo', 'general')"
            alt="copyright"
            class="ms-2"
            ref="imgCopyrightLogo"
        /></span>
      </div>
    </div>
  </Layout>
</template>
